import convertToOption from '../utils/convert-to-option';

export const invoiceCancelationLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSeDPWbVD2lZWwQqzuIOaj9Zq18Rn4xJug_H5ETaIpjrf9-U0A/viewform';

export const bookingEntryTypes = {
  MEDIA: { label: 'Media', value: 'media' },
  NON_MEDIA: { label: 'NonMedia', value: 'nonMedia' },
  MANUAL: { label: 'Manual', value: 'manual' },
  CO_INVEST: { label: 'CoInvest', value: 'coInvest' },
};

export const SYSTEM_GENERATED_USER_NAME = 'system';

export const allStatusesEnum = {
  DRAFT: { label: 'Draft', value: 'Draft' },
  IN_REVIEW: { label: 'In Review', value: 'In Review' },
  CHANGES_REQUESTED: { label: 'Changes Requested', value: 'Changes Requested' },
  APPROVED: { label: 'Approved', value: 'Approved' },
  EXPORTED: { label: 'Exported', value: 'Exported' },
  CANCELED: { label: 'Canceled', value: 'Canceled' },
};

export const invoiceStatuses = [
  allStatusesEnum.DRAFT,
  allStatusesEnum.IN_REVIEW,
  allStatusesEnum.CHANGES_REQUESTED,
  allStatusesEnum.APPROVED,
  allStatusesEnum.EXPORTED,
  allStatusesEnum.CANCELED,
];

export const sapInvoiceStatusesEnum = {
  ORDER_PENDING: { label: 'Order Pending', value: 'orderPending' },
  ORDER_CREATED: { label: 'Order Created', value: 'orderCreated' },
  INVOICED: { label: 'Invoiced', value: 'invoiced' },
  INVOICE_REVERSED: { label: 'Invoice Reversed', value: 'invoiceReversed' },
  PAID: { label: 'Paid', value: 'paid' },
  BILLING_CONTENT_CANCELED: {
    label: 'Billing Content Canceled',
    value: 'billingContentCanceled',
  },
  BILLING_CONTENT_ERROR: {
    label: 'Billing Content Error',
    value: 'billingContentError',
  },
  OUTPUT_CREATED: { label: 'Output Created', value: 'outputCreated' },
};

export const invoiceSapStatuses = [
  sapInvoiceStatusesEnum.ORDER_PENDING,
  sapInvoiceStatusesEnum.ORDER_CREATED,
  sapInvoiceStatusesEnum.INVOICED,
  sapInvoiceStatusesEnum.INVOICE_REVERSED,
  sapInvoiceStatusesEnum.PAID,
  sapInvoiceStatusesEnum.BILLING_CONTENT_CANCELED,
  sapInvoiceStatusesEnum.BILLING_CONTENT_ERROR,
  sapInvoiceStatusesEnum.OUTPUT_CREATED,
];

export const cancellationReasonOptions = [
  'Double invoiced',
  'Incorrect BP',
  'Incorrect distribution channel',
  'Incorrect division',
  'Incorrect posting period',
  'Incorrect service date',
  'Incorrect SO type',
  'Incomplete order',
  'Missing PO',
  'Pricing error',
  'Proforma',
  'Quantity error',
  'Reversed',
  'Wrong item description',
  'Wrong payment term',
  'Wrong pick up address',
].map(convertToOption);
